/** Permission key for HealthLake medical record designation (confirm with BE/product if renamed). */
export const MEDICAL_RECORD_DESIGNATION_PERMISSION = 'medical_chronology';

export const MEDICAL_RECORD_PERMISSION_TOAST = "You don't have permission to designate medical records for this matter";

export const MEDICAL_RECORD_DEMOTE_CONFIRM_MESSAGE =
  'Are you sure you want to mark this file as not a Medical Record? The original file will not be deleted, but it will not be considered for Medical Chronology.';

/** Shown after demote trigger API accepts (async cleanup still running). */
export const MEDICAL_RECORD_DEMOTE_STARTED_TOAST = 'Demotion will take some time. Once demoted, we will let you know.';

/** Shown when healthlake_demotion_completed WebSocket arrives. */
export const MEDICAL_RECORD_DEMOTE_COMPLETED_TOAST = 'Demotion completed successfully.';

/** Shown when audio/video cannot be designated as medical records (upload checkbox + Mark menu). */
export const MEDICAL_RECORD_AV_RESTRICTED_REASON = 'Audio and video cannot be marked as medical records';

export const PROMOTION_QUERY_KEY = 'doc-promotion-status';
